/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import * as API from "../../framework/API/api";
import { ENTITYNAME, PUBLISHING_SOURCE, PLATFORMTYPE, SOCKET_EVENTS, LOCALSTORAGE_KEY, MODULE, FILEURL, LOGEVENT, VODTYPE, TRANSMISSION_PUBLISH_STATUS, TOAST_TYPES, CONTRACT_TAX } from "../../framework/constant/constant";
import { Grid, GridColumn as Column, GRID_COL_INDEX_ATTRIBUTE } from "@progress/kendo-react-grid";
import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { EditPageHeader } from "../../components/EditPageHeader";
import ContractCollectionSelection from "./ContractCollectionSelection";
import { ContractCommandCell, DropDownCell } from "./ContractCommandCell";
import { CheckboxCell } from '../../framework/forms/helpercomponents/CustomGridCells/CheckBoxCell';
import moment from "moment";
import { useTranslation } from "../../locale/useTranslation";
import AddRoundButton from "../../framework/forms/helpercomponents/buttons/AddRoundButton";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { ArrayCell } from "../../framework/forms/helpercomponents/CustomGridCells/ArrayCell";
import { utility } from "../../framework/utility/utilityProvider";
import socket from "../../framework/socket/socket";
import { ContractTitleBlackoutDateEditForm } from "./ContractTitleBlackoutDateEditForm";
import { ContractTitleEditForm } from "./ContractTitleEditForm";
import { ContractAddLinearRightsForm } from "./ContractAddLinearRightsForm";
import ContractPaymentSchedule from "./ContractPaymentSchedule";
import { MenuCommandCell } from "../../framework/forms/helpercomponents/CustomGridCells/MenuCommandCell ";
import { contractTitleMenuModel } from "../../framework/forms/helpercomponents/contextMenu/menus/collectionMenuModel";
import RoundButton from "../../framework/forms/helpercomponents/buttons/RoundButton";
import MediaEpisodeHistory from "../Planning/MediaEpisodeHistory";
import { DateOnlyCell, LocalDateTimeColumn } from "../../framework/forms/helpercomponents/CustomGridCells/DateCell";
import ContractRunReport from "./ContractRunReport";
import BossDialog from "../../components/BossDialog";
import CollectionSelection from "../../framework/forms/CollectionSelection";
import AmortizationRuleReport from "./AmortizationRuleReport";
import { EnumCell } from "../../framework/forms/helpercomponents/CustomGridCells/EnumCell";
import { useTableKeyboardNavigation } from "@progress/kendo-react-data-tools";
import { TransmissionBrowser } from "../MediaLibrary/NodeTreeView/TransmissionBrowser";
import { ConfirmAlert } from "../../ConfirmAlert";
import ToastNotification from "../../components/ToastNotification";
import SyndicateRightReport from "./SyndicateRightReport";
import ContractAttachmentForm from "./ContractAttachmentForm";
import ContractAdditionalCostForm from "./ContractAdditionalCostForm";
import ContractPaymentInformationForm from "./ContractPaymentInformationForm";
import ContractCreditDebitNotesForm from "./ContractCreditDebitNotesForm";

//when deleting contract delete mediadealrights on basis of source_id

function ContractEditForm(props) {

    const currentUser = utility.getValue(LOCALSTORAGE_KEY.userData);
    const { SID } = useParams();
    const loc = useLocation();
    const [licensor, setLicensor] = useState([]);
    const [playTime, setPlayTime] = useState([]);
    const [gridData, setGridData] = useState([]);

    const [platform, setPlatform] = useState([]);
    const [region, setRegion] = useState([]);
    const [showMediaSelectionCollection, setShowMediaSelectionCollection] = useState(false);
    const [removedMedia, setRemovedMedia] = useState([]);
    const [tabNumber, setTabNumber] = React.useState("1");
    const [showBlackOutDate, setShowBlackOutDate] = useState(false);
    const [showWorkFlow, setShowWorkFlow] = useState(false);
    const [workFlow, setWorkFlow] = useState([]);
    const [showLinearEditForm, setShowLinearEditForm] = useState(false);
    const [contractPaymentScheduleData, setContractPaymentScheduleData] = useState({});
    const [filterData, setFilterData] = useState([]);
    const [showHistory, setShowHistory] = useState(false);
    const [showContractRunReport, setShowContractRunReport] = useState(false);
    const [showParentContract, setShowParentContract] = useState(false);
    const [amortizationRules, setAmortizationRules] = useState([]);

    const selectedIndexRef = useRef(0);
    const editingIndexRef = useRef(null);
    const setSelectedIndexRef = (data) => {
        selectedIndexRef.current = data;
    }
    const [showContractTitleEditForm, setShowContractTitleEditForm] = useState(false);
    const [showaAmortizationRuleReport, setShowaAmortizationRuleReport] = useState(false);
    const [contracttype, setContractType] = useState([]);
    const [purchasetype, setPurchaseType] = useState([]);
    const [showaSyndicateRightReport, setShowaSyndicateRightReport] = useState(false);
    const [hasUnsavedContractTitleChanges, setHasUnsavedContractTitleChanges] = useState(false);
    const [showAttachmentForm, setShowAttachmentForm] = useState(false);
    const [attachmentsData, setAttachmentsData] = useState([]);
    const [additionalCostData, setAdditionalCostData] = useState([]);
    const [paymentInfoData, setPaymentInfoData] = useState([]);
    const [creditDebitNoteData, setCreditDebitNoteData] = useState([]);
    const [showAdditionalCostForm, setShowAdditionalCostForm] = useState(false);
    const [showPaymentInfoForm, setShowPaymentInfoForm] = useState(false);
    const [showCreditDebitNoteForm, setShowCreditDebitNoteForm] = useState(false);
    const [titlesTabNumber, setTitlesTabNumber] = useState("1");

    console.log(additionalCostData)

    const navigate = useNavigate();
    const lang = useTranslation();

    let blankDataItem = {
        SID: SID,
        ContractNumber: "",
        Licensor: {},
        Payee: {},
        Archive: false,
        PromotionalExcerpts: '',
        GoverningLaws: '',
        AmortizationRule: {},
        ContractType: {},
        PurchaseType: {},
        IsSigned: false,
        SupplierContractNo: "",
        Title: "",
        CustomTitle: "",
        Remarks: "",
        StatusTracking: {
            CreationDate: "",
            ConfirmationDate: "",
            DispatchDate: "",
            SignedDate: "",
            ExpiryDate: "",
            CancelledDate: ""
        },
        ContractTax: {
            WithholdingTax: {},
            DoubleTaxationAgreementTax: {},
            CorporateTax: {}
        }
    }

    const [dataItem, setDataItem] = useState(blankDataItem);
    const [workflowItem, setWorkflowItem] = useState({})
    const [contractTaxValues, setContractTaxValues] = useState([]);

    useEffect(() => {
        loadcombo();
    }, []);

    const MyArrayCell = (props) => (
        <ArrayCell {...props} />
    )

    const handleMainTabChange = (event, newValue) => {
        setTabNumber(`${newValue}`);
    };

    const handleTitleTabChange = (event, newValue) => {
        setTitlesTabNumber(`${newValue}`);
        setDataItem({
            ...dataItem,
            PlatformType: PLATFORMTYPE[parseInt(newValue) - 1],
        });
        setContractPaymentScheduleData(contractPaymentScheduleData);
        setFilterData(gridData.filter(x => x.PlatformType?.SID == newValue));
    };

    const loadEditData = async () => {

        let res = await API.getEntity(ENTITYNAME.Contract, parseInt(SID));
        console.log(res.data);
        if (res.success && res.data) {
            let statusTracking = res.data.StatusTracking || {};
            let contractTax = res.data.ContractTax || {};

            setDataItem({
                ...blankDataItem, ...res.data,
                ContractNumber: res.data.SID ? loc.state?.copy ? 'Copy of ' + res.data.ContractNumber : res.data.ContractNumber : res.data.ContractNumber,
                StatusTracking: {
                    CreationDate: statusTracking.CreationDate ? utility.convertMilisecondsToDateString(statusTracking.CreationDate) : "",
                    ConfirmationDate: statusTracking.ConfirmationDate ? utility.convertMilisecondsToDateString(statusTracking.ConfirmationDate) : "",
                    DispatchDate: statusTracking.DispatchDate ? utility.convertMilisecondsToDateString(statusTracking.DispatchDate) : "",
                    SignedDate: statusTracking.SignedDate ? utility.convertMilisecondsToDateString(statusTracking.SignedDate) : "",
                    ExpiryDate: statusTracking.ExpiryDate ? utility.convertMilisecondsToDateString(statusTracking.ExpiryDate) : "",
                    CancelledDate: statusTracking.CancelledDate ? utility.convertMilisecondsToDateString(statusTracking.CancelledDate) : "",
                },
                ContractTax: {
                    WithholdingTax: contractTax.WithholdingTax ? { _id: contractTax.WithholdingTax, Description: utility.getKeyByValue(CONTRACT_TAX, contractTax.WithholdingTax) } : {},
                    DoubleTaxationAgreementTax: contractTax.DoubleTaxationAgreementTax ? { _id: contractTax.DoubleTaxationAgreementTax, Description: utility.getKeyByValue(CONTRACT_TAX, contractTax.DoubleTaxationAgreementTax) } : {},
                    CorporateTax: contractTax.CorporateTax ? { _id: contractTax.CorporateTax, Description: utility.getKeyByValue(CONTRACT_TAX, contractTax.CorporateTax) } : {},
                }
            });

            if (res.data.Attachments) {
            setAttachmentsData(res.data.Attachments || []);
            setAdditionalCostData(res.data.AdditionalCosts || []);
            setPaymentInfoData(res.data.PaymentInformation || []);
            setCreditDebitNoteData(res.data.CreditDebitNotes || []);
            }

            if (res.data._id && !loc.state?.copy) {

                var mediaDealRightsRes = await API.getData(ENTITYNAME.MediaDealRights, { query: [['PublishingSource', '=', 'contract'], ['source_id', '=', res.data._id?.toString() ?? ""]] });
                if (mediaDealRightsRes.success) {

                    let groupedData = mediaDealRightsRes.data.reduce((acc, item) => {
                        if (!acc[item.uniqueIdentifier]) {
                            acc[item.uniqueIdentifier] = [];
                        }
                        acc[item.uniqueIdentifier].push(item);
                        return acc;
                    }, {});

                    let tempData = [];
                    Object.keys(groupedData).forEach(key => {
                        tempData.push(groupedData[key][0]);
                    });

                    setGridData(tempData);
                    setFilterData(tempData);
                }

                setContractPaymentScheduleData(res.data.PaymentSchedule);
            }

        }
        else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    }

    const loadcombo = async () => {
        let licensorRes = await API.getDataLookup(ENTITYNAME.Licensor, { sort: { Description: 1 } });
        setLicensor(licensorRes.data);
        let playTimeRes = await API.getDataLookup(ENTITYNAME.PlayTime, { sort: { Description: 1 } });
        setPlayTime(playTimeRes.data);
        // let platformType = await API.getDataLookup(ENTITYNAME.PlatformType, {sort: { Description: 1 }});
        // setPlatformType(platformType.data);
        let region = await API.getDataLookup(ENTITYNAME.Region, { sort: { Description: 1 } });
        setRegion(region.data);
        let platform = await API.getDataLookup(ENTITYNAME.Platform, { sort: { Description: 1 } });
        setPlatform(platform.data);
        let workFlows = await API.getDataLookup(ENTITYNAME.Workflow, { sort: { Name: 1 } });
        setWorkFlow(workFlows.data)
        let AmortizationRuleRes = await API.getDataLookup(ENTITYNAME.AmortizationRule, { sort: { Description: 1 } });
        setAmortizationRules(AmortizationRuleRes.data)
        let ContracttypeRes = await API.getDataLookup(ENTITYNAME.ContractType, { sort: { Name: 1 } });
        setContractType(ContracttypeRes.data);
        let purchasetypeRes = await API.getDataLookup(ENTITYNAME.PurchaseType, { sort: { Name: 1 } });
        setPurchaseType(purchasetypeRes.data);
        const contractTaxRes = Object.keys(CONTRACT_TAX).map(key => ({
            _id: CONTRACT_TAX[key],
            Description: key
        }));
        setContractTaxValues(contractTaxRes);

        if (SID > 0) {
            loadEditData();
        }

    }

    const onChange = (e) => {

        if (e.target.name == "IsUnlimited") {
            dataItem.Exhibitions = 0;
            dataItem.Repeats = 0;
            dataItem.PlayTimeNumber = 0;
            dataItem.PlayTime = {};
            setDataItem({ ...dataItem, IsUnlimited: !dataItem.IsUnlimited });
        }
        else if (e.target.name == "VODType") {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value._id });
        }
        else if (e.target.name == "Archive" || e.target.name == "IsSigned") {
            setDataItem({ ...dataItem, [e.target.name]: !dataItem[e.target.name] });
        }
        else if (e.target.name == 'IsExclusive') {
            setDataItem({ ...dataItem, IsExclusive: !dataItem.IsExclusive, ExclusiveStartDate: '', ExclusiveEndDate: '' });
        }
        else if (["WithholdingTax", "DoubleTaxationAgreementTax", "CorporateTax"].includes(e.target.name)) {
            setDataItem({
                ...dataItem,
                ContractTax: {
                    ...dataItem.ContractTax,
                    [e.target.name]: e.target.value
                }
            });
        }
        else if (["CreationDate", "ConfirmationDate", "DispatchDate", "SignedDate", "ExpiryDate", "CancelledDate"].includes(e.target.name)) {
            setDataItem({
                ...dataItem,
                StatusTracking: {
                    ...dataItem.StatusTracking,
                    [e.target.name]: e.target.value
                }
            });
        }
        else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }
    }

    const onAddNonLinearMedia = () => {

        // validating form inputs first

        if (!utility.isValidDate(dataItem.PublishStartDate)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.invalid_start_date });
            return;
        }
        if (!utility.isValidDate(dataItem.PublishEndDate)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.invalid_end_date });
            return;
        }
        if (dataItem.PublishStartDate >= dataItem.PublishEndDate) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.end_date_should_be_greater_than_start_date_error_message });
            return;
        }

        if (dataItem.Platform == undefined || dataItem.Platform.length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_platform_error_message });
            return;
        }

        if (dataItem.Region == undefined || dataItem.Region.length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_region_error_message });
            return;
        }

        if (dataItem.VODType == undefined || dataItem.VODType == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_vod_type_validation_error_message });
            return;
        }

        if (dataItem.VODType > 0 && dataItem.VODType == VODTYPE.TVOD && dataItem.Runs == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_runs_error_message });
            return;
        }

        setShowMediaSelectionCollection(!showMediaSelectionCollection);
    }

    const updateLinearGridData = (dataList) => {

        // Grid data linear
        let linearGridData = gridData.filter((x) => x.PlatformType?.SID == PLATFORMTYPE[0].SID);
        const newlyAddedData = dataList.filter(x => !linearGridData.some(c => c.ContractTitle.media_id == x.ContractTitle.media_id));
        setGridData((old) => [...old, ...newlyAddedData]);
        setFilterData((old) => [...old, ...newlyAddedData]);
    }

    const updateNonLinearGridData = (dataList) => {

        let finalData = [];
        // preparing final data
        for (let i = 0; i < dataList.length; i++) {
            let obj = dataList[i];
            let data = {
                _id: undefined,
                ContractSID: 0, ContractNumber: '', Licensor: {}, Payee: {},
                PublishingSource: 'contract',
                ContractTitle: { media_id: obj._id, Title: obj.Title, AssetId: obj.AssetId },
                MediaCategory: obj.MediaCategory,
                PublishStartDate: new Date(dataItem.PublishStartDate).getTime(),
                PublishEndDate: new Date(dataItem.PublishEndDate).getTime(),
                PlatformType: PLATFORMTYPE[1],
                Platform: dataItem.Platform ?? [],
                VODType: dataItem.VODType,
                Runs: dataItem.VODType && dataItem.VODType == VODTYPE.TVOD ? dataItem.Runs : "",
                Channel: [],
                Region: dataItem.Region ?? [],
                Amount: 0, Currency: {}, IsUnlimited: false, Exhibitions: 0, Repeats: 0, PlayTimeNumber: 0, PlayTime: {},
                IsExclusive: false, ExclusiveStartDate: 0, ExclusiveEndDate: 0, BlackOutDates: [],
                Archive: false,
            }
            finalData.push(data);
        }

        // Grid data linear
        let nonLinearGridData = gridData.filter((x) => x.PlatformType?.SID == PLATFORMTYPE[1].SID);
        const newlyAddedData = finalData.filter(x => !nonLinearGridData.some(c => c.ContractTitle.media_id == x.ContractTitle.media_id));

        setGridData((old) => [...old, ...newlyAddedData]);
        setFilterData((old) => [...old, ...newlyAddedData]);
    }

    // Functions to modify grid data
    const onRemoveContractTitle = (dataItem) => {

        const dropIndex = gridData.indexOf(dataItem);
        if (dropIndex > -1) { // only splice array when item is found
            gridData.splice(dropIndex, 1);
        }

        setGridData(gridData);
        setFilterData(gridData.filter(x => x.PlatformType.SID == tabNumber));

        // Remove Only if Contract In Edit Stage
        if (dataItem._id) {
            setRemovedMedia((old) => [...old, dataItem]);
        }
        ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.delete_successfully_grid_data_success_toast_message });
    };
    
    const onEditAdditionalCost = (dataItem, dataIndex) => {
        editingIndexRef.current = dataIndex;
        setSelectedIndexRef(cloneData(dataItem));
        setShowAdditionalCostForm(true);
    };

    const saveAdditionalCost = (record) => {
        const idx = editingIndexRef.current;
        if (idx !== null && idx > -1) {
            let newData = additionalCostData.map((item, i) => i === idx ? record : item);
            setAdditionalCostData(newData);
        } else {
            setAdditionalCostData([...additionalCostData, record]);
        }
        setShowAdditionalCostForm(false);
        editingIndexRef.current = null;
        setSelectedIndexRef(null);
    };
    const AdditionalCostCommandCell = (props) => (
        <td className="k-command-cell">
            <RoundButton 
                icon="edit" 
                onClick={() => onEditAdditionalCost(props.dataItem, props.dataIndex)} 
                title="Edit" 
            />
            <RoundButton 
                icon="trash" 
                style={{ marginLeft: "5px" }} 
                onClick={() => {
                    setAdditionalCostData(additionalCostData.filter((item, i) => i !== props.dataIndex));
                }} 
                title="Delete"
            />
        </td>
    );

    const PaymentInfoCommandCell = (props) => (
        <td className="k-command-cell">
            <RoundButton 
                icon="edit" 
                onClick={() => onEditPaymentInfo(props.dataItem, props.dataIndex)} 
                title="Edit" 
            />
            <RoundButton 
                icon="trash" 
                style={{ marginLeft: "5px" }} 
                onClick={() => {
                    setPaymentInfoData(paymentInfoData.filter((item, i) => i !== props.dataIndex));
                }} 
                title="Delete"
            />
        </td>
    );

    const CreditDebitNoteCommandCell = (props) => (
        <td className="k-command-cell">
            <RoundButton 
                icon="edit" 
                onClick={() => onEditCreditDebitNote(props.dataItem, props.dataIndex)} 
                title="Edit" 
            />
            <RoundButton 
                icon="trash" 
                style={{ marginLeft: "5px" }} 
                onClick={() => {
                    setCreditDebitNoteData(creditDebitNoteData.filter((item, i) => i !== props.dataIndex));
                }} 
                title="Delete"
            />
        </td>
    );

    const AttachmentCommandCell = (props) => (
        <td className="k-command-cell">
            {props.dataItem.url && (
                <RoundButton
                    icon="download"
                    onClick={() => {
                        if (props.dataItem.url) {
                            API.downloadFile(props.dataItem.url.split('/').pop());
                        }
                    }}
                    title="Download"
                />
            )}
            <RoundButton
                icon="trash"
                style={{ marginLeft: "5px" }}
                onClick={() => {
                    setAttachmentsData(attachmentsData.filter((item, i) => i !== props.dataIndex));
                }}
                title={lang.delete_tooltip}
            />
        </td>
    );



    const onEditPaymentInfo = (dataItem, dataIndex) => {
        editingIndexRef.current = dataIndex;
        setSelectedIndexRef(cloneData(dataItem));
        setShowPaymentInfoForm(true);
    };

    const savePaymentInfo = (record) => {
        const idx = editingIndexRef.current;
        if (idx !== null && idx > -1) {
            let newData = paymentInfoData.map((item, i) => i === idx ? record : item);
            setPaymentInfoData(newData);
        } else {
            setPaymentInfoData([...paymentInfoData, record]);
        }
        setShowPaymentInfoForm(false);
        editingIndexRef.current = null;
        setSelectedIndexRef(null);
    };

    const onEditCreditDebitNote = (dataItem, dataIndex) => {
        editingIndexRef.current = dataIndex;
        setSelectedIndexRef(cloneData(dataItem));
        setShowCreditDebitNoteForm(true);
    };

    const saveCreditDebitNote = (record) => {
        const idx = editingIndexRef.current;
        if (idx !== null && idx > -1) {
            let newData = creditDebitNoteData.map((item, i) => i === idx ? record : item);
            setCreditDebitNoteData(newData);
        } else {
            setCreditDebitNoteData([...creditDebitNoteData, record]);
        }
        setShowCreditDebitNoteForm(false);
        editingIndexRef.current = null;
        setSelectedIndexRef(null);
    };

    const onEditContractTitle = (dataItem) => {
        setShowContractTitleEditForm(true);
        setSelectedIndexRef(cloneData(dataItem));
        //setSelectedIndexRef(dataItem);
    };

    const onEditBlackOutDate = (dataItem) => {
        setSelectedIndexRef(dataItem);
        setShowBlackOutDate(true);
    }

    const MyCommandCell = (props) => (
        <MenuCommandCell
            {...props}
            onEditBlackOutDate={onEditBlackOutDate}
            onEditContractTitle={onEditContractTitle}
            onRemoveContractTitle={onRemoveContractTitle}
            myMenuModel={contractTitleMenuModel}
        />
    )

    const CommandCell = (props) => (

        <ContractCommandCell
            {...props}
            onEditBlackOutDate={onEditBlackOutDate}
            onEditContractTitle={onEditContractTitle}
            onRemoveContractTitle={onRemoveContractTitle}
        />
    )

    const isValid = () => {

        if (dataItem.ContractNumber == '' || dataItem.ContractNumber == undefined) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_contarct_number_contract_error_message });
            return false;
        }
        if (!dataItem.Licensor || Object.keys(dataItem.Licensor).length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_licensor_error_message });
            return false;
        }
        if (!dataItem.Payee || Object.keys(dataItem.Payee).length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_payee_error_message });
            return false;
        }
        // if (gridData.length == 0) {
        // ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_attach_atleast_one_media_contract_error_message });
        //     return false;
        // }
        return true;
    }

    const saveWorkFlow = () => {
        if (isValid()) {
            setShowWorkFlow(true)
        }
    }

    const onSave = async (saveAndCreateWorkOrder = false) => {

        if (saveAndCreateWorkOrder && Object.keys(workflowItem).length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_workflow_error_message });
            return;
        }

        let uploadedAttachments = [];
        for (let attachment of attachmentsData) {
            if (attachment.file) {
                let uploadRes = await API.uploadFile(attachment.file);
                console.log({uploadRes})
                let fileUrl ='';
                if (uploadRes?.success && typeof uploadRes?.data === 'string') {
                    fileUrl = uploadRes.data;
                } else if (uploadRes?.success && uploadRes?.data?.url) {
                    fileUrl = uploadRes.data.url;
                } else {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: uploadRes?.message || "File upload failed" });
                    return; 
                }
                
                uploadedAttachments.push({
                    Description: attachment.Description,
                    Remarks: attachment.Remarks,
                    filename: attachment.filename,
                    url: fileUrl,
                    AddOn: attachment.AddOn,
                    AddBy: attachment.AddBy,
                });
            } else {
                uploadedAttachments.push(attachment);
            }
        }
        setAttachmentsData(uploadedAttachments);

        const saveData = {
            _id: dataItem._id,
            SID: loc.state?.copy ? 0 : parseInt(dataItem.SID),
            ContractNumber: dataItem.ContractNumber,
            Licensor: {
                _id: dataItem.Licensor._id,
                SID: dataItem.Licensor.SID,
                Name: dataItem.Licensor.Name
            },
            Payee: {
                _id: dataItem.Payee._id,
                SID: dataItem.Payee.SID,
                Name: dataItem.Payee.Name
            },
            PromotionalExcerpts: dataItem.PromotionalExcerpts,
            GoverningLaws: dataItem.GoverningLaws,
            Archive: dataItem.Archive ?? false,
            ContractTitles: gridData.map(m => { return m.ContractTitle }),
            ContractTitlesWT: gridData.map(m => { return m.ContractTitle.Title }).join(', '),
            ContractPaymentSchedule: contractPaymentScheduleData,
            Attachments: attachmentsData,
            AdditionalCosts: additionalCostData,
            PaymentInformation: paymentInfoData,
            CreditDebitNotes: creditDebitNoteData,
            SupplierContractNo: dataItem.SupplierContractNo,
            Title: dataItem.Title,
            CustomTitle: dataItem.CustomTitle,
            Remarks: dataItem.Remarks,
            StatusTracking: {
                CreationDate: dataItem.StatusTracking?.CreationDate ? utility.convertStringDatetoMilliseconds(dataItem.StatusTracking.CreationDate) : "",
                ConfirmationDate: dataItem.StatusTracking?.ConfirmationDate ? utility.convertStringDatetoMilliseconds(dataItem.StatusTracking.ConfirmationDate) : "",
                DispatchDate: dataItem.StatusTracking?.DispatchDate ? utility.convertStringDatetoMilliseconds(dataItem.StatusTracking.DispatchDate) : "",
                SignedDate: dataItem.StatusTracking?.SignedDate ? utility.convertStringDatetoMilliseconds(dataItem.StatusTracking.SignedDate) : "",
                ExpiryDate: dataItem.StatusTracking?.ExpiryDate ? utility.convertStringDatetoMilliseconds(dataItem.StatusTracking.ExpiryDate) : "",
                CancelledDate: dataItem.StatusTracking?.CancelledDate ? utility.convertStringDatetoMilliseconds(dataItem.StatusTracking.CancelledDate) : "",
            },
            ContractTax: {
                WithholdingTax: dataItem.ContractTax?.WithholdingTax && Object.keys(dataItem.ContractTax.WithholdingTax).length > 0 ? dataItem.ContractTax.WithholdingTax?._id : {},
                DoubleTaxationAgreementTax: dataItem.ContractTax?.DoubleTaxationAgreementTax && Object.keys(dataItem.ContractTax.DoubleTaxationAgreementTax).length > 0 ? dataItem.ContractTax.DoubleTaxationAgreementTax?._id : {},
                CorporateTax: dataItem.ContractTax?.CorporateTax && Object.keys(dataItem.ContractTax.CorporateTax).length > 0 ? dataItem.ContractTax.CorporateTax?._id : {},
            },
            ParentContract: dataItem?.ParentContract && Object.keys(dataItem?.ParentContract).length > 0 ? {
                _id: dataItem?.ParentContract?._id,
                ContractNumber: dataItem?.ParentContract?.ContractNumber
            } : {},
            AmortizationRule: dataItem?.AmortizationRule && Object.keys(dataItem?.AmortizationRule).length > 0 ? {
                _id: dataItem?.AmortizationRule?._id,
                Description: dataItem?.AmortizationRule?.Description,
                RuleText: dataItem?.AmortizationRule?.RuleText
            } : {},
            ContractType: dataItem.ContractType ? {
                _id: dataItem.ContractType._id,
                SID: dataItem.ContractType.SID,
                Name: dataItem.ContractType.Name
            } : {},
            PurchaseType: dataItem.PurchaseType ? {
                _id: dataItem.PurchaseType._id,
                SID: dataItem.PurchaseType.SID,
                Name: dataItem.PurchaseType.Name
            } : {},
            IsSigned: dataItem.IsSigned ?? false,
            Attachments: uploadedAttachments,
            AdditionalCosts: additionalCostData,
            PaymentInformations: paymentInfoData,
            CreditDebitNotes: creditDebitNoteData,
            checkDuplicate: true,
            query: [["ContractNumber", "=", dataItem.ContractNumber]],
        }
        // need to implement validation
        if (loc.state?.copy) {
            delete saveData._id;
        }

        let res = await API.saveData(ENTITYNAME.Contract, saveData)
        let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.CONTRACT, data: res.data, message: res.message };
        API.SaveLogs(logData);

        if (!res.success) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
        else {
            //create workorders

            if (saveAndCreateWorkOrder) {

                let workOrderRes = await API.createWorkOrder(res.data, workflowItem);
                //fetch workflow
                let workflow = await API.getEntity(ENTITYNAME.Workflow, 1);
                socket()?.emit(SOCKET_EVENTS.onSocketNotification, { user: currentUser, module: MODULE.WORK_ORDER, data: workOrderRes.data, reciever: { role: workflow.data.StartingRole, user: { _id: '', SID: 0, name: 'All' } } });
            }

            // adding contract properties in titles for saving in media deal rights
            gridData.forEach((x) => {
                x.ContractNumber = dataItem.ContractNumber;
                x.ContractSID = res.data.SID;
                x.Licensor = {
                    _id: dataItem.Licensor._id,
                    SID: dataItem.Licensor.SID,
                    Name: dataItem.Licensor.Name
                };
                x.Payee = {
                    _id: dataItem.Payee._id,
                    SID: dataItem.Payee.SID,
                    Name: dataItem.Payee.Name
                };
                x.media_id = x.ContractTitle.media_id;
                x.PublishingSource = PUBLISHING_SOURCE.Contract;
            });

            let response = await API.createAndUpdateDealRights(gridData, res.data._id, true);

            // Delete Deal Rights 
            if (removedMedia.length > 0) {
                await API.deleteDealRights(removedMedia?.map(x => x?._id), true);
            }

            if (response.success) {
                onClose();
            } else {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: response.message });
                return;
            }

        }

    }

    const saveContractTitleEditData = (data) => {
        const oldData = selectedIndexRef.current;
        const changed = isContractTitleChanged(oldData, data);
        if (changed) {
            setHasUnsavedContractTitleChanges(true);
        }
        let index = gridData.findIndex((x) => x.ContractTitle.media_id == data.ContractTitle.media_id && x.PlatformType.SID == data.PlatformType.SID);
        let newData = gridData.map((item, i) => index === i ? { ...data, modBy: { _id: currentUser._id, name: currentUser.name } } : item);
        setGridData(newData);
        setFilterData(newData.filter(x => x.PlatformType.SID == tabNumber));
        setSelectedIndexRef(data);
    }

    const setBlackOutDate = (dataItem) => {

        let newData = gridData.map((item) => {
            return (
                item._id === dataItem[0]._id
                    ? {
                        ...item,
                        BlackOutDates: dataItem[0].BlackOutDates,
                        modBy: { _id: currentUser._id, name: currentUser.name }
                    }
                    : item
            )
        });
        setGridData(newData);
        setFilterData(newData.filter(x => x.PlatformType.SID == tabNumber));
    }

    const handelContractPaymentSchedule = (dataItem) => {
        setContractPaymentScheduleData(dataItem);
    }

    let defaultKeys = [];
    const onSearch = (e) => {
        e.preventDefault();
        const keyword = e.target.value?.trim();
        var datakey = Object.keys(gridData[0]?.ContractTitle);
        datakey?.map((key) => {
            if (key == "Title" && !defaultKeys.includes(key)) {
                defaultKeys.push(key);
            } else if (key == "AssetId" && !defaultKeys.includes(key)) {
                defaultKeys.push(key);
            }
        });
        let dataStore = [];
        if (keyword != "") {
            defaultKeys?.map((item) => {
                let filterDataValue = gridData.filter((obj) => obj?.ContractTitle[item] && obj?.ContractTitle[item].toLowerCase().includes(keyword.toLowerCase()));
                if (filterDataValue.length != 0) {
                    dataStore.push(...filterDataValue);
                }
            });
            const uniqData = [...new Set(dataStore)];
            setFilterData(uniqData);
        } else {
            setFilterData(gridData);
        }
    }

    const downloadExcel = async () => {

        let getData = filterData?.filter((x) => x.PlatformType?.Description == PLATFORMTYPE[0].Description);

        if (getData.length == 0) {
            ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: lang.no_data_found_error_message });
            return;
        }

        let storeData = getData.map(x => {
            return {
                Title: x.ContractTitle.Title,
                AssetId: x.ContractTitle.AssetId,
                MediaCategory: x.MediaCategory.Description,
                Channel: x.Channel.map(obj => obj.FullChannelName).join(','),
                Region: x.Region.map(obj => obj.Description).join(','),
                Amount: x.Amount,
                Currency: x.Currency.Description,
                StartDate: moment(new Date(x.PublishStartDate)).format("YYYY-MM-DD"),
                EndDate: moment(new Date(x.PublishEndDate)).format("YYYY-MM-DD"),
                Exhibitions: x.Exhibitions,
                Repeats: x.Repeats,
                PlayTimeNumber: x.PlayTimeNumber,
                PlayTime: x.PlayTime.Description ? x.PlayTime.Description : "",
                IsUnlimited: x.IsUnlimited,
                IsExclusive: x.IsExclusive,
                ExclusiveStartDate: x.ExclusiveStartDate,
                ExclusiveEndDate: x.ExclusiveEndDate,
                BlackOutDates: x.BlackOutDates ? x.BlackOutDates?.map(obj => obj.StartDate + ' - ' + obj.EndDate).join(',') : "",

            }
        })
        let res = await API.exportCSV(storeData);
        if (res.success) {
            window.open(FILEURL().BASEURL + 'downloadReport/' + res.data)
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.successfully_download_success_message });
        }
        else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    }

    const showMediaEpisodeHistory = () => {
        setShowHistory(!showHistory);
    }

    const parentContractData = (dataList) => {
        setDataItem({ ...dataItem, "ParentContract": dataList[0] });
    }

    const onClose = () => {
        if (loc.state && loc.state.prevPath) {
            navigate(loc.state.prevPath)
        } else {
            navigate("/home/Contract");
        }
    }

    const MyContractStatusCell = (props) => {

        const currDate = new Date().getTime();

        let value = "Inactive";
        if (currDate >= props.dataItem.PublishStartDate && currDate < props.dataItem.PublishEndDate) {
            value = 'Active';
        };

        let newStyle = {
            ...props.style,
            margin: "0px",
            textAlign: "center",
        };

        if (value && value.length > 0) {
            newStyle = {
                ...props.style,
                padding: "2px 3px 0px 3px",
                backgroundColor: value == 'Active' ? '#2ba666' : "red",
                height: props.titleHeight ? props.titleHeight : "23px",
                border: '0.05em solid #9a9c92',
                borderRadius: '4px',
                textAlign: "center",
                color: "white",
                fontWeight: "normal",
                fontSize: "12px",
                verticalAlign: "center",
                fontFamily: "Roboto",
                letterSpacing: "0.6px",
                margin: "0px",
            }
        }

        return <td
            colSpan={props.colSpan}
            role={"gridcell"}
            aria-colindex={props.ariaColumnIndex}
            aria-selected={props.isSelected}
            {...{
                [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex,
            }}
            {...useTableKeyboardNavigation(props.id)}
            // style={{textAlign : 'center'}}
            style={props.style}
        >
            <p style={newStyle}>{value}</p>
        </td>
    }

    const cloneData = (data) => {
        return JSON.parse(JSON.stringify(data));
    };
    const isContractTitleChanged = (oldData, newData) => {
        if (!oldData || !newData) {
            return false;
        }
        const normalize = (obj) => {
            const cloned = cloneData(obj);
            delete cloned.modBy;
            delete cloned.addBy;
            return cloned;
        };
        const oldValue = normalize(oldData);
        const newValue = normalize(newData);

        return JSON.stringify(oldValue) !== JSON.stringify(newValue);
    };

    const showSyndicateRightReports = () => {
        if (hasUnsavedContractTitleChanges) {
            ToastNotification({
                type: TOAST_TYPES.WARNING,
                title: lang.invalid_error_message_title,
                message: "Contract Title has been changed. Please save the contract first before exporting the Syndicate Report."
            });
            return;
        }
        setShowaSyndicateRightReport(true)
    }

    return (<>
        <div className="row m-1">
            <div className="col-12">
                <EditPageHeader title={`${lang.contract_sub_menu}  -> ` + (dataItem.ContractNumber == "" ? `${lang.new_title_editpageheader}` : ` ${dataItem.ContractNumber}`)} onSubmit={() => { if (isValid()) { onSave(false) } }} onCancel={onClose} showSaveAndCreateWorkOrder={true} onSaveAndCreateWorkOrder={saveWorkFlow} />
                <div className="row">
                    <div className="col pr-1">
<div style={{ marginBottom: '16px', padding: '12px 14px', background: '#fafafa', borderRadius: '6px', border: '1px solid #cccccc', marginTop: "10px" }}>
                    <div style={{ fontSize: '10px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1px', color: '#3A3633', marginBottom: '10px', paddingLeft: '8px', borderLeft: '3px solid #3A3633' }}>
                        {lang.information_label}
                    </div>
                    <div className="row">
                        <div className="col-3">
                            <div className="form-group">
                                <label htmlFor="ContractNumber">{lang.contract_number_label} *</label>
                                <input type="text" className="form-control form-control-sm" name="ContractNumber" value={dataItem.ContractNumber} onChange={onChange} required />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group">
                                <label htmlFor="Licensor">{lang.licensor_supplier_label} *</label>
                                <DropDownList
                                    style={{ backgroundColor: "white" }}
                                    data={licensor}
                                    name="Licensor"
                                    textField="Name"
                                    dataItemKey="_id"
                                    value={dataItem.Licensor}
                                    onChange={onChange}
                                />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group">
                                <label htmlFor="SupplierContractNo">{lang.supplier_contract_number}</label>
                                <input type="text" className="form-control form-control-sm" name="SupplierContractNo" value={dataItem.SupplierContractNo} onChange={onChange} />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group">
                                <label htmlFor="Payee">{lang.buyer_payee_label} *</label>
                                <DropDownList
                                    style={{ backgroundColor: "white" }}
                                    data={licensor}
                                    name="Payee"
                                    textField="Name"
                                    dataItemKey="_id"
                                    value={dataItem.Payee}
                                    onChange={onChange}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-3">
                            <div className="form-group">
                                <label htmlFor="ContractType">{lang.contract_type_label}</label>
                                <DropDownList
                                    style={{ backgroundColor: "white" }}
                                    data={contracttype}
                                    name="ContractType"
                                    textField="Name"
                                    dataItemKey="_id"
                                    value={dataItem.ContractType}
                                    onChange={onChange}
                                />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group">
                                <label htmlFor="PurchaseType">{lang.PurchaseType_PackageType_label}</label>
                                <DropDownList
                                    style={{ backgroundColor: "white" }}
                                    data={purchasetype}
                                    name="PurchaseType"
                                    textField="Name"
                                    dataItemKey="_id"
                                    value={dataItem.PurchaseType}
                                    onChange={onChange}
                                />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group">
                                <label htmlFor="Title">{lang.title_label}</label>
                                <input type="text" className="form-control form-control-sm" name="Title" value={dataItem.Title} onChange={onChange} />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group">
                                <label htmlFor="CustomTitle">{lang.custom_title_label}</label>
                                <input type="text" className="form-control form-control-sm" name="CustomTitle" value={dataItem.CustomTitle} onChange={onChange} />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-3">
                            <div className="form-group">
                                <label htmlFor="AmortizationRule">{lang.amortization_rule_label}</label>
                                <DropDownList
                                    style={{ backgroundColor: "white" }}
                                    data={amortizationRules}
                                    name="AmortizationRule"
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.AmortizationRule}
                                    onChange={onChange}
                                />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group">
                                <label htmlFor="ParentContract">{lang.parent_contract_label}</label><br />
                                <div style={{ display: "flex" }}>
                                    <input name="ParentContract" type="text" className="d-inline form-control form-control-sm" value={dataItem?.ParentContract?.ContractNumber || ""} onChange={onChange} disabled={true} />
                                    <button type="button" title='Select Contract' className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary "
                                        style={{ height: "30px", marginLeft: "5px" }} onClick={() => { setShowParentContract(true) }}>
                                        <i className="fa-solid fa-ellipsis-vertical"></i>
                                    </button>
                                    <button type="button" title='Clear Contract' className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary "
                                        style={{ height: "30px", marginLeft: "5px" }} onClick={() => { setDataItem({ ...dataItem, ParentContract: {} }) }}>
                                        <i className="fa-solid fa-xmark"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="form-group">
                                <label htmlFor="Remarks">{lang.remarks_label}</label>
                                <input type="text" className="form-control form-control-sm" name="Remarks" value={dataItem.Remarks} onChange={onChange} />
                            </div>
                        </div>
                    </div>


                    {/* Combined Tax Section */}

                            <div style={{ fontSize: '10px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1px', color: '#3A3633', marginBottom: '10px', paddingLeft: '8px', borderLeft: '3px solid #3A3633' }}>
                                {lang.contract_tax_label}
                            </div>
                            <div className="row">
                                <div className="col-4">
                                    <div className="form-group">
                                        <label htmlFor="WithholdingTax">{lang.withholding_tax_label}</label>
                                        <DropDownList
                                            style={{ backgroundColor: "white" }}
                                            data={contractTaxValues}
                                            name="WithholdingTax"
                                            textField="Description"
                                            dataItemKey="_id"
                                            value={dataItem.ContractTax?.WithholdingTax}
                                            onChange={onChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-4">
                                    <div className="form-group">
                                        <label htmlFor="DoubleTaxationAgreementTax">{lang.double_taxation_agreement_tax_label}</label>
                                        <DropDownList
                                            style={{ backgroundColor: "white" }}
                                            data={contractTaxValues}
                                            name="DoubleTaxationAgreementTax"
                                            textField="Description"
                                            dataItemKey="_id"
                                            value={dataItem.ContractTax?.DoubleTaxationAgreementTax}
                                            onChange={onChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-4">
                                    <div className="form-group">
                                        <label htmlFor="CorporateTax">{lang.corporate_tax_label}</label>
                                        <DropDownList
                                            style={{ backgroundColor: "white" }}
                                            data={contractTaxValues}
                                            name="CorporateTax"
                                            textField="Description"
                                            dataItemKey="_id"
                                            value={dataItem.ContractTax?.CorporateTax}
                                            onChange={onChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-auto pl-1 mt-2 d-flex flex-column justify-content-between" style={{ marginBottom: '16px' }}>
                        <div style={{ padding: '12px 14px', background: '#fafafa', borderRadius: '6px', border: '1px solid #cccccc', width: 'fit-content', flex: 1, marginBottom: '12px' }}>
                            <div style={{ fontSize: '10px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1px', color: '#3A3633', marginBottom: '12px', paddingLeft: '8px', borderLeft: '3px solid #3A3633' }}>
                                {lang.status_tracking_label}
                            </div>
                            <div>
                                <div className="form-group d-flex align-items-center justify-content-between mb-2" style={{ gap: '10px' }}>
                                    <label htmlFor="CreationDate" className="mb-0 pr-2" style={{ fontSize: '13px', whiteSpace: 'nowrap', minWidth: '125px' }}>{lang.creation_date_label}</label>
                                    <input type="date" className="form-control form-control-sm" style={{ width: '135px' }} name="CreationDate" value={dataItem.StatusTracking?.CreationDate || ""} onChange={onChange} />
                                </div>
                                <div className="form-group d-flex align-items-center justify-content-between mb-2" style={{ gap: '10px' }}>
                                    <label htmlFor="ConfirmationDate" className="mb-0 pr-2" style={{ fontSize: '13px', whiteSpace: 'nowrap', minWidth: '125px' }}>{lang.confirmation_date_label}</label>
                                    <input type="date" className="form-control form-control-sm" style={{ width: '135px' }} name="ConfirmationDate" value={dataItem.StatusTracking?.ConfirmationDate || ""} onChange={onChange} />
                                </div>
                                <div className="form-group d-flex align-items-center justify-content-between mb-2" style={{ gap: '10px' }}>
                                    <label htmlFor="DispatchDate" className="mb-0 pr-2" style={{ fontSize: '13px', whiteSpace: 'nowrap', minWidth: '125px' }}>{lang.dispatch_date_label}</label>
                                    <input type="date" className="form-control form-control-sm" style={{ width: '135px' }} name="DispatchDate" value={dataItem.StatusTracking?.DispatchDate || ""} onChange={onChange} />
                                </div>
                                <div className="form-group d-flex align-items-center justify-content-between mb-2" style={{ gap: '10px' }}>
                                    <label htmlFor="SignedDate" className="mb-0 pr-2" style={{ fontSize: '13px', whiteSpace: 'nowrap', minWidth: '125px' }}>{lang.signed_date_label}</label>
                                    <input type="date" className="form-control form-control-sm" style={{ width: '135px' }} name="SignedDate" value={dataItem.StatusTracking?.SignedDate || ""} onChange={onChange} />
                                </div>
                                <div className="form-group d-flex align-items-center justify-content-between mb-2" style={{ gap: '10px' }}>
                                    <label htmlFor="ExpiryDate" className="mb-0 pr-2" style={{ fontSize: '13px', whiteSpace: 'nowrap', minWidth: '125px' }}>{lang.expiry_date_label}</label>
                                    <input type="date" className="form-control form-control-sm" style={{ width: '135px' }} name="ExpiryDate" value={dataItem.StatusTracking?.ExpiryDate || ""} onChange={onChange} />
                                </div>
                                <div className="form-group d-flex align-items-center justify-content-between mb-2" style={{ gap: '10px' }}>
                                    <label htmlFor="CancelledDate" className="mb-0 pr-2" style={{ fontSize: '13px', whiteSpace: 'nowrap', minWidth: '125px' }}>{lang.cancelled_date_label}</label>
                                    <input type="date" className="form-control form-control-sm" style={{ width: '135px' }} name="CancelledDate" value={dataItem.StatusTracking?.CancelledDate || ""} onChange={onChange} />
                                </div>
                            </div>
                        </div>
                        <div className="d-flex align-items-center px-1 pb-1" style={{ gap: '20px' }}>
                            <div className="form-group mb-0 d-flex align-items-center">
                                <input type={"checkbox"} id="IsSigned" name={"IsSigned"}
                                    onChange={(e) => onChange(e)}
                                    value={dataItem.IsSigned}
                                    checked={dataItem.IsSigned} />
                                <label htmlFor="IsSigned" className="ml-1 mb-0" style={{ fontSize: '13px', cursor: 'pointer' }}>{lang.is_signed_label}</label>
                            </div>
                            <div className="form-group mb-0 d-flex align-items-center">
                                <input type={"checkbox"} id="Archive" name={"Archive"}
                                    onChange={(e) => onChange(e)}
                                    value={dataItem.Archive}
                                    checked={dataItem.Archive} />
                                <label htmlFor="Archive" className="ml-1 mb-0" style={{ fontSize: '13px', cursor: 'pointer' }}>{lang.archive}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <Box sx={{ width: '100%', typography: 'body1' }}>
                    <TabContext value={tabNumber}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <TabList onChange={handleMainTabChange} aria-label="main tabs">
                                <Tab label={lang.titles_label} value="1" />
                                <Tab label={lang.general_label} value="2" />
                                <Tab label={lang.additional_cost_label} value="3" />
                                <Tab label={lang.attachments_label} value="4" />
                                <Tab label={lang.payment_schedule_label} value="5" />
                                <Tab label={lang.payment_information_label} value="6" />
                                <Tab label={lang.credit_debit_notes_label} value="7" />
                            </TabList>
                        </Box>
                        <TabPanel value={"1"} style={{ padding: 0, paddingTop: '10px' }}>
                            <TabContext value={titlesTabNumber}>
                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                    <TabList onChange={handleTitleTabChange} aria-label="titles tabs">
                                        <Tab label={lang.linear_label} value="1" />
                                        <Tab label={lang.non_linear_label} value="2" />
                                        <Tab label={lang.transmission_label} value="3" />
                                    </TabList>
                                </Box>
                                <TabPanel value={"1"}>
                                    
                            {showLinearEditForm && <ContractAddLinearRightsForm onCancel={() => setShowLinearEditForm(false)} updateLinearGridData={updateLinearGridData} />}

                            <div className="row">
                                <div className="col">
                                    <AddRoundButton onClick={() => setShowLinearEditForm(true)} title={lang.add_linear_button_tooltip} />
                                    <RoundButton icon='download' onClick={() => downloadExcel()} style={{ marginLeft: '5px' }} title={lang.download_button_tooltip} />
                                    <RoundButton icon='history' onClick={() => showMediaEpisodeHistory()} style={{ marginLeft: '5px' }} title={lang.show_history_button_text} />
                                    <RoundButton icon='ioxhost' onClick={() => setShowContractRunReport(true)} style={{ marginLeft: '5px' }} title={lang.contract_run_report_button_tooltip} />
                                    <RoundButton icon='line-chart' onClick={() => setShowaAmortizationRuleReport(true)} style={{ marginLeft: '5px' }} title={lang.amortization_rule_report_button_tooltip} />
                                    <RoundButton icon='newspaper' onClick={() => showSyndicateRightReports()} style={{ marginLeft: '5px' }} title={lang.syndicate_right_report_button_tooltip} />
                                    <div className="pull-right">
                                        <div className="input-group input-group mb-3" >
                                            <input type="text" className="form-control shadow-inset-2 pt-0 pb-0 ml-2" id="searchInput" aria-label="type 2 or more letters" placeholder={lang.search_button_text} onChange={onSearch} />
                                            <button id="search" style={{ border: "0px", backgroundColor: "white", height: "38px" }} >
                                                <div className="input-group-append">
                                                    <span className="input-group-text">
                                                        <i style={{ margin: "4px 0px" }} className="fa fa-search" />
                                                    </span>
                                                </div>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Grid style={{ height: '48vh', overflow: "hidden" }} resizable={true}
                                data={filterData?.filter((x) => x.PlatformType?.Description == PLATFORMTYPE[0].Description)}>
                                <Column cell={MyCommandCell} width="55px" />
                                <Column field="ContractTitle.Title" title={lang.title_column} width={'150px'} editable={false} />
                                <Column field="ContractTitle.AssetId" title={lang.assetId_column} width={'150px'} editable={false} />
                                <Column field="MediaCategory.Description" title={lang.media_category_column} width={'150px'} editable={false} />
                                <Column field="Channel" format="FullChannelName" cell={MyArrayCell} width={'150px'} title={lang.channel_column} />
                                <Column field="Region" format="Description" cell={MyArrayCell} width={'150px'} title={lang.region_column} />
                                <Column field="Amount" width={'150px'} title={lang.amount_column} />
                                <Column field="RevShare" width={'150px'} title={lang.revenue_share_column} />
                                <Column field="Currency.Description" width={'150px'} title={lang.currency_column} />
                                <Column field="PublishStartDate" title={lang.start_date_column} cell={DateOnlyCell} width={'150px'} />
                                <Column field="PublishEndDate" title={lang.end_date_column} cell={DateOnlyCell} width={'150px'} />
                                <Column field="Exhibitions" title={lang.exhibition_column} editable={false} width={'150px'} />
                                <Column field="Repeats" title={lang.repeat_column} width={'125px'} editable={false} />
                                <Column field="PlayTimeNumber" title={lang.play_time_number_column} width={'125px'} editable={false} />
                                <Column field="PlayTime" title={lang.playTime_column} cell={DropDownCell} width={'150px'} editable={false} />
                                <Column field="IsUnlimited" title={lang.is_unlimited_column} width={'105px'} editable={false} cell={CheckboxCell} />
                                <Column field="IsExclusive" title={lang.is_exclusive_column} width={'105px'} editable={false} cell={CheckboxCell} />
                                <Column field="ExclusiveStartDate" title={lang.exclusive_start_date_column} cell={DateOnlyCell} width={'150px'} />
                                <Column field="ExclusiveEndDate" title={lang.exclusive_end_date_column} cell={DateOnlyCell} width={'150px'} />
                                <Column field="BlackOutDates" format="StartDate" cell={MyArrayCell} title={lang.black_out_start_date_column} width={'125px'} />
                                <Column field="BlackOutDates" format="EndDate" cell={MyArrayCell} title={lang.black_out_end_date_column} width={'125px'} />
                                <Column field="addBy.name" title={lang.added_by_column} width={'125px'} />
                                <Column field="modBy.name" title={lang.modified_by_column} width={'125px'} />
                            </Grid>
                            <div className="pull-right m-1" >{lang.total_label} {gridData?.filter((x) => x.PlatformType?.Description == PLATFORMTYPE[0].Description)?.length ?? 0}</div>
                        
                            </TabPanel>
                            <TabPanel value={"2"}>
                                    
                            <div className="row">
                                <div className="col">
                                    <div className="form-group">
                                        <label htmlFor="">{lang.start_date_label}</label>
                                        <input type="date" className="form-control form-control-sm" name="PublishStartDate" value={dataItem.PublishStartDate} onChange={(e) => onChange(e)} />
                                    </div>
                                </div>
                                <div className="col">
                                    <div className="form-group">
                                        <label htmlFor="">{lang.end_Date_label}</label>
                                        <input type="date" className="form-control form-control-sm" name="PublishEndDate" value={dataItem.PublishEndDate} onChange={(e) => onChange(e)} />
                                    </div>
                                </div>
                                <div className="col">
                                    <div className="form-group">
                                        <label htmlFor="TabView">{lang.platform_label} *</label><br />
                                        <MultiSelect
                                            style={{ backgroundColor: "white" }}
                                            data={platform}
                                            name="Platform"
                                            textField="Description"
                                            dataItemKey="_id"
                                            value={dataItem.Platform}
                                            onChange={onChange}
                                        />
                                    </div>
                                </div>
                                <div className="col">
                                    <div className="form-group">
                                        <label htmlFor="TabView">{lang.region_label} *</label><br />
                                        <MultiSelect
                                            style={{ backgroundColor: "white" }}
                                            textField="Description"
                                            dataItemKey="_id"
                                            data={region}
                                            name="Region"
                                            value={dataItem.Region}
                                            onChange={onChange}
                                        />
                                    </div>
                                </div>
                                <div className="col">
                                    <div className="form-group">
                                        <label htmlFor="">{lang.VODtype_label} *</label>
                                        <DropDownList
                                            style={{ backgroundColor: 'white', border: '1px solid lightgrey' }}
                                            data={Object.keys(VODTYPE).map((item) => ({ Name: item, _id: VODTYPE[item] }))}
                                            name={"VODType"}
                                            textField="Name"
                                            dataItemKey="_id"
                                            value={{ _id: dataItem.VODType, Name: utility.getKeyByValue(VODTYPE, dataItem.VODType) }}
                                            onChange={onChange}
                                        />
                                    </div>
                                </div>
                                {dataItem.VODType && dataItem.VODType == VODTYPE.TVOD && <div className="col">
                                    <div className="form-group">
                                        <label htmlFor="">{lang.runs_label}</label>
                                        <input type="number" className="form-control form-control-sm" name="Runs" value={dataItem.Runs} onChange={(e) => onChange(e)} min={0} />
                                    </div>
                                </div>}
                            </div>
                            {/* <div className="row">
                                <div className="col-3">
                                    <div className="form-group">
                                        <label htmlFor="">{lang.VODtype_label} *</label>
                                        <DropDownList
                                            style={{ backgroundColor: 'white', border: '1px solid lightgrey' }}
                                            data={Object.keys(VODTYPE).map((item) => ({ Name: item, _id: VODTYPE[item] }))}
                                            name={"VODType"}
                                            textField="Name"
                                            dataItemKey="_id"
                                            value={{ _id: dataItem.VODType, Name: utility.getKeyByValue(VODTYPE, dataItem.VODType) }}
                                            onChange={onChange}
                                        />
                                    </div>
                                </div>
                                {dataItem.VODType && dataItem.VODType == VODTYPE.TVOD && <div className="col-3">
                                    <div className="form-group">
                                        <label htmlFor="">{lang.runs_label}</label>
                                        <input type="number" className="form-control form-control-sm" name="Runs" value={dataItem.Runs} onChange={(e) => onChange(e)} min={0} />
                                    </div>
                                </div>}
                            </div> */}
                            <div className="row">
                                <div className="col-8">
                                    <AddRoundButton style={{ marginBottom: '5px' }} onClick={onAddNonLinearMedia} title={lang.attach_media_button_tooltip} />
                                </div>
                                <div className="col-4">
                                    <div className="pull-right">{lang.total_label} {gridData?.filter((x) => x.PlatformType?.Description == PLATFORMTYPE[1].Description)?.length ?? 0}</div>
                                </div>
                            </div>
                            <Grid style={{ height: "35vh", marginTop: "2px", overflow: "hidden", marginBottom: '20px' }} resizable={true}
                                data={gridData.filter((x) => x.PlatformType?.Description == PLATFORMTYPE[1].Description)}>
                                <Column cell={CommandCell} width="95px" />
                                <Column field="ContractTitle.Title" title={lang.title_column} editable={false} />
                                <Column field="ContractTitle.AssetId" title={lang.assetId_column} editable={false} />
                                <Column field="Platform" format="Description" cell={MyArrayCell} title={lang.platform_column} />
                                <Column field="Region" format="Description" cell={MyArrayCell} width={'150px'} title={lang.region_column} />
                                <Column field="PublishStartDate" title={lang.start_date_column} cell={DateOnlyCell} />
                                <Column field="PublishEndDate" title={lang.end_date_column} cell={DateOnlyCell} />
                                <Column field="Status" title={lang.status_column} cell={MyContractStatusCell} />
                                <Column field="VODType" cell={EnumCell} title={lang.vod_type_column} />
                                <Column field="Runs" title={lang.runs_column} />
                            </Grid>
                        
                            </TabPanel>
                            <TabPanel value={"3"}>
                                    
                            <TransmissionBrowser isFromMedia={false} isFromContract={true} selectedNode={dataItem} showToggle={true} query={[['source', '=', ENTITYNAME.Contract], ['source_id', '=', dataItem?._id]]} mainStyle={{ height: 'calc(100vh - 360px)' }} gridStyle={{ height: 'calc(100vh - 580px)' }} entityName={PUBLISHING_SOURCE.Contract} />
                        
                            </TabPanel>
                            </TabContext>
                        </TabPanel>
                        <TabPanel value={"2"}>
                            
                            <div className="row">
                                <div className="col-12">
                                    <label>{lang.promotional_excerpts_label}</label>
                                    <textarea
                                        className="form-control form-control-sm"
                                        name="PromotionalExcerpts"
                                        style={{ height: '24vh' }}
                                        value={dataItem.PromotionalExcerpts}
                                        onChange={(e) => onChange(e)}
                                    />
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className="col-12">
                                    <label>{lang.governing_laws_label}</label>
                                    <textarea
                                        className="form-control form-control-sm"
                                        name="GoverningLaws"
                                        style={{ height: '24vh' }}
                                        value={dataItem.GoverningLaws}
                                        onChange={(e) => onChange(e)}
                                    />

                                </div>
                            </div>
                        
                        </TabPanel>
                        <TabPanel value={"3"}>
                            <div className="row">
                                <div className="col">
                                    <AddRoundButton onClick={() => { setSelectedIndexRef(null); editingIndexRef.current = null; setShowAdditionalCostForm(true); }} title={lang.add_additional_cost_label} />
                                </div>
                            </div>
                            <Grid style={{ height: '48vh', overflow: "hidden", marginTop: "10px" }} resizable={true}
                                data={additionalCostData}>
                                <Column cell={AdditionalCostCommandCell} width="100px" />
                                <Column field="ContractTitle.Title" title={lang.contract_title_column} />
                                <Column field="Supplier.Name" title={lang.supplier_label} />
                                <Column field="CostType" title={lang.cost_type_label} />
                                <Column field="Currency.Description" title={lang.currency_label} />
                                <Column field="Amount" title={lang.amount_label} />
                                <Column field="Tax" title={lang.tax_label} />
                                <Column field="Inventoried" title={lang.inventoried_label} cell={(props) => <td>{props.dataItem.Inventoried ? "Yes" : "No"}</td>} />
                                <Column field="AddOn" title="Add On" cell={LocalDateTimeColumn}/>
                                <Column field="AddBy.Name" title="Add By" />
                            </Grid>

                        </TabPanel>
                        <TabPanel value={"4"}>

                            <div className="row">
                                <div className="col">
                                    <AddRoundButton onClick={() => setShowAttachmentForm(true)} title={lang.add_attachment_label} />
                                </div>
                            </div>
                            <Grid style={{ height: '48vh', overflow: "hidden", marginTop: "10px" }} resizable={true}
                                data={attachmentsData}>
                                <Column cell={AttachmentCommandCell} width="100px" />
                                <Column field="filename" title={lang.file_name_column} />
                                <Column field="Description" title={lang.description_column} />
                                <Column field="AddOn" title="Add On" cell={LocalDateTimeColumn}/>
                                <Column field="AddBy.Name" title="Add By" />
                            </Grid>

                        </TabPanel>
                        <TabPanel value={"5"}>
                            
                            <ContractPaymentSchedule data={gridData.filter((x) => x.PlatformType?.Description == PLATFORMTYPE[0].Description)} contractPaymentSchedule={contractPaymentScheduleData} setContractPaymentSchedule={handelContractPaymentSchedule} />
                        
                        </TabPanel>
                        <TabPanel value={"6"}>
                            
                            <div className="row">
                                <div className="col">
                                    <AddRoundButton onClick={() => { setSelectedIndexRef(null); editingIndexRef.current = null; setShowPaymentInfoForm(true); }} title={lang.add_payment_information_label} />
                                </div>
                            </div>
                            <Grid style={{ height: '48vh', overflow: "hidden", marginTop: "10px" }} resizable={true}
                                data={paymentInfoData}>
                                <Column cell={PaymentInfoCommandCell} width="100px" />
                                <Column field="CostType" title="Cost Type" />
                                <Column field="Supplier.Name" title="Supplier" />
                                <Column field="Amount" title="Amount" />
                                <Column field="TaxAmount" title="Tax Amount" />
                                <Column field="TotalAmount" title="Total Amount" />
                                <Column field="Remarks" title="Remarks" />
                                <Column field="AddOn" title="Add On" cell={LocalDateTimeColumn}/>
                                <Column field="AddBy.Name" title="Add By" />
                            </Grid>

                        </TabPanel>
                        <TabPanel value={"7"}>
                            
                            <div className="row">
                                <div className="col">
                                    <AddRoundButton onClick={() => { setSelectedIndexRef(null); editingIndexRef.current = null; setShowCreditDebitNoteForm(true); }} title={lang.add_credit_debit_note_label} />
                                </div>
                            </div>
                            <Grid style={{ height: '48vh', overflow: "hidden", marginTop: "10px" }} resizable={true}
                                data={creditDebitNoteData}>
                                <Column cell={CreditDebitNoteCommandCell} width="100px" />
                                <Column field="CostType" title="Cost Type" />
                                <Column field="CreditDebit.Description" title="Credit/Debit" />
                                <Column field="Supplier.Name" title="Supplier" />
                                <Column field="Amount" title="Amount" />
                                <Column field="TaxAmount" title="Tax Amount" />
                                <Column field="AddOn" title="Add On" cell={LocalDateTimeColumn}/>
                                <Column field="AddBy.Name" title="Add By" />
                            </Grid>

                        </TabPanel>
                    </TabContext>
                </Box>
            </div>
        </div>
        {showMediaSelectionCollection && <ContractCollectionSelection addButtonTitle="Select" title={lang.media_library_dialog_header} wherestatement={['MediaCategory.isLong', '=', true]} setDataList={updateNonLinearGridData} entityname={ENTITYNAME.MediaEpisode} closeForm={onAddNonLinearMedia} width={"50vw"} />}
        {showBlackOutDate && <ContractTitleBlackoutDateEditForm data={selectedIndexRef.current} onCancel={() => setShowBlackOutDate(false)} publishingSource={props.publishingSource ?? PUBLISHING_SOURCE.Contract} setBlackOutDate={setBlackOutDate} />}
        {showWorkFlow &&
            <BossDialog title={lang.workflow_label} onClose={() => { setShowWorkFlow(false); setWorkflowItem({}) }} width={"300px"}>
                <div className="row">
                    <div className="col-12">
                        <EditPageHeader showTitle={false} onSubmit={() => onSave(true)} onCancel={() => { setShowWorkFlow(false); setWorkflowItem({}) }} />
                        <div className="row mt-2 mb-2">
                            <div className='col'>
                                <label>{lang.workflow_label} *</label>
                                <DropDownList
                                    style={{ backgroundColor: "white" }}
                                    data={workFlow}
                                    name="WorkFlow"
                                    textField="Name"
                                    dataItemKey="_id"
                                    value={workflowItem}
                                    onChange={(e) => setWorkflowItem(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </BossDialog>}
        {showContractTitleEditForm && <ContractTitleEditForm data={selectedIndexRef.current} onCancel={() => setShowContractTitleEditForm(false)} saveEditData={saveContractTitleEditData} />}
        {showHistory && <MediaEpisodeHistory isFromContract={true} showTitle={dataItem.ContractNumber} selectedData={gridData.filter((x) => x.PlatformType?.Description == PLATFORMTYPE[0].Description)} closeForm={() => setShowHistory(false)} />}
        {showContractRunReport && <ContractRunReport selectedData={gridData.filter((x) => x.PlatformType?.Description == PLATFORMTYPE[0].Description)} closeForm={() => setShowContractRunReport(false)} />}
        {showParentContract && <CollectionSelection entityname={ENTITYNAME.Contract} closeForm={() => setShowParentContract(false)} setDataList={parentContractData} title={lang.select_contract_collection_header} width={"50vw"} mode={"single"} />}
        {showaAmortizationRuleReport && <AmortizationRuleReport item={dataItem} onClose={() => setShowaAmortizationRuleReport(false)} />}
        {showaSyndicateRightReport && <SyndicateRightReport item={dataItem} onClose={() => setShowaSyndicateRightReport(false)} />}
        {showAttachmentForm && <ContractAttachmentForm cancelEdit={() => setShowAttachmentForm(false)} onSaveData={(attachment) => {
            setAttachmentsData([...attachmentsData, attachment]);
            setShowAttachmentForm(false);
        }} />}
        {showAdditionalCostForm && <ContractAdditionalCostForm data={selectedIndexRef.current} cancelEdit={() => { setShowAdditionalCostForm(false); setSelectedIndexRef(null); }} onSaveData={saveAdditionalCost} />}
        {showPaymentInfoForm && <ContractPaymentInformationForm data={selectedIndexRef.current} cancelEdit={() => { setShowPaymentInfoForm(false); setSelectedIndexRef(null); }} onSaveData={savePaymentInfo} />}
        {showCreditDebitNoteForm && <ContractCreditDebitNotesForm data={selectedIndexRef.current} cancelEdit={() => { setShowCreditDebitNoteForm(false); setSelectedIndexRef(null); }} onSaveData={saveCreditDebitNote} />}
    </>)
}

export default ContractEditForm;